import { localElectronics, localMenClothing, localWomenClothing } from './localProducts';
import { USD_TO_PKR, discountedUSD } from './currency';

const FSA = 'https://fakestoreapi.com/products';


export async function getProducts(category) {
	// fetch remote products
	let remote = [];
	try {
		const url = category ? `${FSA}/category/${encodeURIComponent(category)}` : FSA;
		const res = await fetch(url);
		if (res.ok) remote = await res.json();
	} catch {}

	// Remove all jewelry products from remote
	const filterJewelry = p => (p.category && p.category.toLowerCase().includes('jewel')) ? false : true;
	// also filter out specific remote products we don't want to show (e.g. WD Elements external drives)
	const blockedTitleKeywords = [
		'wd',
		'elements',
		'external hard',
		'hard drive',
		'external'
	];
	const filterBlocked = p => {
		const t = (p.title || '').toString().toLowerCase();
		return !blockedTitleKeywords.some(k => t.includes(k));
	};
	remote = remote.filter(filterJewelry).filter(filterBlocked);

	// merge local datasets for All or specific categories
	let list = remote;
	if (!category) {
		list = [...remote, ...localElectronics, ...localMenClothing, ...localWomenClothing];
	} else if (category === 'electronics') {
		list = [...remote, ...localElectronics];
	} else if (category === "men's clothing") {
		list = [...remote, ...localMenClothing];
	} else if (category === "women's clothing") {
		list = [...remote, ...localWomenClothing];
	}

	// Remove all jewelry products and blocked titles from merged list
	list = list.filter(filterJewelry).filter(filterBlocked);

	// Filter out products whose discounted PKR price exceeds 15000
	const MAX_PKR = 15000;
	const filtered = list.filter(p => {
		const priceUSD = Number(p.price) || 0;
		const hasCustomDiscount = typeof p.discountRate === 'number';
		const finalUSD = hasCustomDiscount ? priceUSD * p.discountRate : discountedUSD(priceUSD);
		const finalPKR = Math.round(finalUSD * USD_TO_PKR);
		return finalPKR <= MAX_PKR;
	});

	return filtered;
}

export async function getProductById(id) {
	// local first
	const sid = String(id);
	const local = (
		localElectronics.find(p => String(p.id) === sid) ||
		localMenClothing.find(p => String(p.id) === sid) ||
		localWomenClothing.find(p => String(p.id) === sid)
	);
	if (local) return local;
	const res = await fetch(`${FSA}/${id}`);
	return res.json();
}
